import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiMarkingSettingsService {

  constructor(
    private api: ApiService
  ) { }

   /**
   * 
   * @param params 
   * @param moduleName 
   * @returns 
   */
    getReferences(params: ReferenceParams, moduleName: string): Observable<Res> {

      return this.api.post('references/' + moduleName, params, 'private');
    }
  
    /**
     * 
     * @returns Observable<Res>
     */
    uploadInfo(): Observable<Res> {
  
      return this.api.get('marking/getCredentialData', '', 'private', 'integrationMarking');
    }
  
  
    /**
     * 
     * @param params any
     * @returns Observable<Res>
     */
    uploadSave(params: any): Observable<Res> {
  
      return this.api.post('marking/saveCredentialData', params, 'private', 'integrationMarking');
    }
}
